import { nameToFirstName } from "@aclymatepackages/converters";

import { fetchAuth } from "./firebase";
import { fetchOurApi } from "./utils/apiCalls";
import { getAccountId } from "./accountHelpers";
import { scrubSensitiveKeys } from "./scrubSensitiveKeys";

const { analytics } = window;
const isProduction = process.env.REACT_APP_ENVIRONMENT === "production";

export const analyticsPage = (name) => {
  if (isProduction) {
    return analytics.page(name);
  }
};

export const analyticsIdentify = async (user) => {
  const { uid, email, displayName: name } = user || {};

  window.dataLayer = window.dataLayer || [];

  if (isProduction) {
    const id = getAccountId();
    const companyId =
      id ||
      (await user.getIdTokenResult().then(({ claims }) => claims.company));

    const firstName = nameToFirstName(name);

    const nameArray = name.split(" ");
    const lastName = nameArray[nameArray.length - 1];

    analytics.identify(uid, {
      name,
      first_name: firstName,
      last_name: lastName,
      email,
      companyId,
      fs_contact: true
    });
    return fetchOurApi({
      user,
      path: "/mixpanel/identify",
      method: "POST",
      data: {
        userId: uid,
        traits: {
          name,
          first_name: firstName,
          last_name: lastName,
          email,
          companyId,
          fs_contact: true
        }
      }
    });
  }
};

export const triggerGoogleEvent = (event, properties, otherData = {}) => {
  if (properties) {
    return window.dataLayer.push({
      event,
      ...otherData,
      listItems: [properties]
    });
  }

  return window.dataLayer.push({ event });
};

const EXPLORER_PQL_EVENTS = new Set([
  "explorer_onboarding_completed",
  "scout_action_card_clicked",
  "survey_started",
  "survey_in_progress",
  "survey_completed",
  "historical_document_uploaded",
  "sustainability_goals_updated"
]);

export const analyticsTrack = async (event, properties = {}) => {
  if (!isProduction) {
    return;
  }

  const auth = fetchAuth();
  const { currentUser: user, email, displayName } = auth || {};
  const { uid } = user || {};

  if (window.Appcues) {
    window.Appcues.track(event);
  }

  const safeProperties = scrubSensitiveKeys(properties);

  const mixpanelCall = fetchOurApi({
    user,
    path: "/mixpanel/track",
    method: "POST",
    data: {
      event,
      properties: {
        ...safeProperties,
        email,
        name: displayName
      },
      userId: uid
    }
  });

  const acFanout = EXPLORER_PQL_EVENTS.has(event)
    ? fetchOurApi({
        user,
        path: "/active-campaign/fire-event",
        method: "POST",
        data: { event, properties: safeProperties }
      })
    : Promise.resolve();

  return Promise.allSettled([mixpanelCall, acFanout]);
};

export const trackPdfReportDownloaded = ({
  companyId,
  year,
  completenessPercent,
  timeFromSurveyCompletionMs,
  triggerPath
}) =>
  analyticsTrack("pdf_report_downloaded", {
    companyId,
    year,
    completenessPercent,
    timeFromSurveyCompletionMs,
    triggerPath
  });

export const trackPdfReportFailed = ({
  companyId,
  year,
  errorMessage,
  triggerPath
}) =>
  analyticsTrack("pdf_report_failed", {
    companyId,
    year,
    errorMessage,
    triggerPath
  });
